// Sidebar.js
import React from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  IconButton,
} from "@mui/material";
import {
  AccountCircle,
  Visibility,
  Settings,
  Menu as MenuIcon,
} from "@mui/icons-material";

const Sidebar = ({ currentView, setCurrentView, collapsed, toggleCollapse }) => {
  const items = [
    { key: "Dashboard", label: "Dashboard", icon: <AccountCircle /> },
    { key: "KYC Logs", label: "KYC Logs", icon: <Visibility /> },
    { key: "Settings", label: "Settings", icon: <Settings /> },
  ];

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "space-between",
        }}
      >
        {!collapsed ? (
          <Box>
            <Typography variant="h6" color="primary" fontWeight="bold">
              Intelli VKYC
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Admin Panel
            </Typography>
          </Box>
        ) : null}
        <IconButton size="small" onClick={toggleCollapse}>
          <MenuIcon />
        </IconButton>
      </Box>

      <List>
        {items.map((it) => (
          <ListItemButton
            key={it.key}
            selected={currentView === it.key}
            onClick={() => setCurrentView(it.key)}
            sx={{ justifyContent: collapsed ? "center" : "flex-start" }}
          >
            <ListItemIcon sx={{ minWidth: collapsed ? "auto" : 56 }}>
              {it.icon}
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary={it.label}
                primaryTypographyProps={{
                  fontWeight: currentView === it.key ? "bold" : "normal",
                  color: currentView === it.key ? "primary" : "inherit",
                }}
              />
            )}
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
